import {CloseDirection, ResultState} from '../comparators/BaseComparator';

export interface DisplayProperties {
    key: string,
    state: ResultState,
    direction?: CloseDirection
    type: DisplayPropertyType
    detailedProperties: DetailedDisplayProperties
    background: string
}

export enum DisplayPropertyType {
    TEXT,
    IMAGE,
    MULTI_IMAGE
}

export interface DetailedDisplayProperties {

}


export function GetBackgroundStyle(state: ResultState): [string, string] {
    switch (state) {
        case ResultState.MATCH:
            return ["#37be75", "white"];
        case ResultState.CLOSE:
            return ["#f4e878", "black"];
        case ResultState.FAIL:
            return ["#920000", "white"];
        case ResultState.FAR:
            return ["#edeae5", "black"];
    }
}
